import ManagerFiles from "./ManagerFiles";

export default ManagerFiles;
